<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Heures Supplémentaires</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-alert border="top" class="my-4" color="#F44336" dark dense v-if="errors.length>0"
                 v-model="alert">
          <h4 class="mt-2">{{ errors.length }}{{ " Erreur" | pluralize(errors.length) }}
            sur {{ excelData.length }} {{ "enregistrement"|pluralize(excelData.length) }}.
            Merci de corriger et de ne réimporter que les enregistrements ci-dessous rejetés, pour éviter
            tout doublon
          </h4>
          <v-row align="center">
            <v-col class="grow">
              <div :key="index" v-for="(error,index) in errors">
                <h5>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{
                    "Matricule (" + error.datas.userId + " - " + error.datas.brigade + ") -> " +
                    error.message
                  }}
                </h5>
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn :elevation="1" @click="closeAlert" fab small
                     style="position:absolute;top:18px;right:12px">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col>
              <v-select :disabled="disableMainBtn" :items="selectDates" @change="depthDate" dense filled
                        full-width hide-details="true" item-text="name"
                        item-value="value" label="Profondeur" return-object solo
                        style="z-index: 200"
                        v-model="depthVal">
                <template v-slot:selection="{ item }">
                                      <span class="d-flex justify-center" style="width: 100%;">
                                        {{ item.name }}
                                      </span>
                </template>
              </v-select>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :disabled="disableMainBtn"
                            :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import {depthDate} from "../../../helper/profondeur";
import Handsontable from "handsontable";
import Vue from "vue";

function customDropDownRender2(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.AutocompleteRenderer.apply(this, arguments);
  cellProperties.data = 'options';
  cellProperties.type = 'dropdown';

  if (col === 6) {
    cellProperties.source = JSON.parse(sessionStorage.getItem("Shifts"));
  }
}

Vue.filter('kb', val => {
  return Math.floor(val / 1024);
});

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "presences",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      fileBtn: true,
      drag_over: false,   // dragging over the target OR any child element
      over_others: false, // dragging over a child element
      files: [],
      lastHighlitedRow: null,
      isdisabled: true,
      menu0: null,
      menu1: null,
      menu2: null,
      type: null,
      elapse: null,
      loading: false,
      loading2: false,
      modal2: false,
      modal3: false,
      toObject: [],
      shifts: [],
      shiftsFull: [],
      selectDates: depthDate,
      depthVal: {
        name: sessionStorage.getItem("depthValChoosedt"),
        value: sessionStorage.getItem("depthValChoosedd")
      },
      heightVal: {
        name: sessionStorage.getItem("heightValChoosedt"),
        value: sessionStorage.getItem("heightValChoosedd")
      },
      editedItem: {
        userId: "",
        shiftName: "",
        shiftDate: "",
        startDateHeuresSup: "",
        startTimeHeuresSup: "",
        endDateHeuresSup: "",
        endTimeHeuresSup: "",
        observations: "",
      },
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      file: "",
      editedIndex: -1,
      errors: [],
      excelData: [],
      brigadetypes: [],
      absencetypes: [],
      arrayAbs: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: {
          items: {
            'remove_row': {
              name: 'Supprimer la ligne'
            }
          }
        },
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: false,
        afterChange: this.afterChangeMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        comment: true,
        className: "htCenter htMiddle",

        colHeaders:
            ["Id Heures Sup", "Matricule", "Nom", "Prénom", "Brigade", "Jour Shift rattaché", "Nom Shift rattaché", "Jour début Heures Sup", "Heure début Heures Sup",
              "Jour fin Heures Sup", "Heure fin Heures Sup", "Observations", "Durée Heures Sup", "Compensation", "Date création", "Matricule créateur"],
        columns: [
          {title: "Id Heures Sup", width: "150px", readOnly: true},
          {title: "Matricule", width: "150px", readOnly: true},
          {title: "Nom", width: "160px", readOnly: true},
          {title: "Prénom", width: "200px", readOnly: true},
          {title: "Brigade", width: "160px", readOnly: true},
          {
            title: "Jour Shift rattaché",
            width: "200px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true
          },
          {
            title: "Nom Shift rattaché",
            width: "200px",
            type: "dropdown",
            renderer: customDropDownRender2,
            allowInvalid: false,
            strict: true
          },
          {
            title: "Jour début Heures Sup",
            width: "200px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true,
            readOnly: true
          },
          {
            title: "Heure début Heures Sup",
            width: "200px",
            type: "time",
            timeFormat: "HH:mm:ss",
            correctFormat: true,
            readOnly: true
          },
          {
            title: "Jour fin Heures Sup",
            width: "200px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true,
            readOnly: true
          },
          {
            title: "Heure fin Heures Sup",
            width: "200px",
            type: "time",
            timeFormat: "HH:mm:ss",
            correctFormat: true,
            readOnly: true
          },
          {title: "Observations", width: "250px"},
          {title: "Durée Heures Sup", width: "180px", readOnly: true},
          {title: "Compensation", width: "150px", type: "checkbox", readOnly: true},
          {
            title: "Date création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
          {title: "Matricule créateur", width: "160px", readOnly: true}
        ],
      }
    }
  },

  created() {
    this.getData(this.depthVal)
    this.loadShifts()
  },

  computed: {
    FormIsValid() {
      return (
          this.editedItem.userId !== "" &&
          this.editedItem.startDateHeuresSup !== "" &&
          this.editedItem.startTimeHeuresSup !== "" &&
          this.editedItem.endDateHeuresSup !== "" &&
          this.editedItem.endTimeHeuresSup !== "" &&
          this.editedItem.observations !== ""
      );
    },

    computedDateFormatted0() {
      return this.formatDate(this.editedItem.shiftDate)
    },

    computedDateFormatted1() {
      return this.formatDate(this.editedItem.startDateHeuresSup)
    },

    computedDateFormatted2() {
      return this.formatDate(this.editedItem.endDateHeuresSup)
    },

    computedDateFormatted11() {
      return this.formatTime(this.editedItem.startTimeHeuresSup)
    },

    computedDateFormatted22() {
      return this.formatTime(this.editedItem.endTimeHeuresSup)
    },
  },

  methods: {
    detacher(row, col) {
      this.text = "Ligne " + row + "  Colonne " + col
      this.showAlert('warning')
    },
    cleared() {
      this.searchName = "";
      this.depthDate();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 1, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    dragEnter(e) {
      if (e.target === this.$refs.others)
        this.over_others = true
      else
        this.drag_over = true
    },
    dragOver(e) {
      if (e.target === this.$refs.others) this.over_others = true
      else this.drag_over = true
    },
    dragLeave(e) {
      if (e.target === this.$refs.others) this.over_others = false
      else if (!this.over_others) this.drag_over = false
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    initdatetime() {
      this.tab = "tab-1";
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;

      this.editedItem.userId = "";
      this.editedItem.shiftDate = "";
      this.editedItem.shiftName = "";
      this.editedItem.startDateHeuresSup = "";
      this.editedItem.startTimeHeuresSup = "";
      this.editedItem.endDateHeuresSup = "";
      this.editedItem.endTimeHeuresSup = "";
      this.editedItem.observations = "";
    },
    initEditedItem() {
      this.editedItem.userId = "";
      this.editedItem.shiftDate = "";
      this.editedItem.shiftName = "";
      this.editedItem.startDateHeuresSup = "";
      this.editedItem.startTimeHeuresSup = "";
      this.editedItem.endDateHeuresSup = "";
      this.editedItem.endTimeHeuresSup = "";
      this.editedItem.observations = "";
    },
    loadShifts() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/shifts/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            sessionStorage.setItem("Shifts", null)
            let datas = response.data.datas;
            this.shiftsFull = datas;
            this.shifts = []
            datas.forEach(item => {
              this.shifts.push(item.shiftName);
            });
            sessionStorage.setItem("Shifts", JSON.stringify(this.shifts))
          })
          .catch(() => {
          });
    },
    getDay(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}`
    },
    getMonth(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}`
    },
    getYear(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}`
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatTime(time) {
      if (!time) return null

      const [hh, mm, ss] = time.split(':')
      return `${hh}:${mm}:${ss}`
    },
    getHour(time) {
      if (!time) return null

      const [hh, mm, ss] = time.split(':')
      return `${hh}`
    },
    getMin(time) {
      if (!time) return null

      const [hh, mm, ss] = time.split(':')
      return `${mm}`
    },
    getSec(time) {
      if (!time) return null

      const [hh, mm, ss] = time.split(':')
      return `${ss}`
    },
    depthDate() {
      if (this.depthVal) {
        sessionStorage.setItem("depthValChoosedd", this.depthVal.value)
        sessionStorage.setItem("depthValChoosedt", this.depthVal.name)
      }
      this.getData(this.depthVal)
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    getData(valeur) {
      this.loading = true
      valeur = this.depthVal.value
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/heuressup/` + moment().subtract(valeur, "days").format("YYYY-MM-DD") + "/" + sessionStorage.getItem("userId")
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                item["userId"],
                this.isEmpty(item["accountLastname"]) ? "" : item["accountLastname"].toUpperCase(),
                this.isEmpty(item["accountFirstname"]) ? "" : item["accountFirstname"].toLowerCase().capitalize(true),
                this.isEmpty(item["brigade"]) ? "" : item["brigade"].toUpperCase(),
                (this.isEmpty("dateShift") || (item["dateShift"] === null)) ? "" : this.convertDate(item["dateShift"]),
                item["nameShift"],
                this.convertDate(item["startDayHeuresSup"]),
                item["startHourHeuresSup"],
                this.convertDate(item["endDayHeuresSup"]),
                item["endHourHeuresSup"],
                item["observations"],
                item["heuresSupDuration"],
                item["compensation"],
                this.datefull(item["creationDate"]),
                item["originUser"]
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
          })
          .catch(() => {
            this.loading = false
          });
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData(this.depthVal)
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    convertDate(val) {
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY");
    },
    close() {
      this.dialog = false;
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
      this.initEditedItem();
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification des Heures Sup.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              this.loading = true
              let obj = {}
              let newObj = {}

              obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]]

              let dateShift = (this.isEmpty(obj[5]) || (obj[5] === null)) ? null : moment(obj[5], "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss");
              if ((dateShift !== null) && (dateShift === "Invalid date")) {
                this.text = "La date du shift est invalide."

                this.showAlert('warning')
                this.loading = false
                this.refresh()
                dialog.close();
                return;
              }

              let sdatetimefullstart = moment(obj[7] + " " + obj[8], "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
              let sdatetimefullend = moment(obj[9] + " " + obj[10], "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")

              var oneDayInMilliseconds = 86400000;
              let days, months, years, daye, monthe, yeare, dayr, monthr, yearr;
              let hours, mins, secs, houre, mine, sece;

              days = this.getDay(moment(sdatetimefullstart).format("YYYY-MM-DD"))
              months = this.getMonth(moment(sdatetimefullstart).format("YYYY-MM-DD"))
              years = this.getYear(moment(sdatetimefullstart).format("YYYY-MM-DD"))

              daye = this.getDay(moment(sdatetimefullend).format("YYYY-MM-DD"))
              monthe = this.getMonth(moment(sdatetimefullend).format("YYYY-MM-DD"))
              yeare = this.getYear(moment(sdatetimefullend).format("YYYY-MM-DD"))

              if (!this.isEmpty(obj[5]) && (obj[5] !== null)) {
                dayr = this.getDay(moment(dateShift).format("YYYY-MM-DD"))
                monthr = this.getMonth(moment(dateShift).format("YYYY-MM-DD"))
                yearr = this.getYear(moment(dateShift).format("YYYY-MM-DD"))
              }

              hours = this.getHour(moment(sdatetimefullstart).format("HH:mm:ss"))
              mins = this.getMin(moment(sdatetimefullstart).format("HH:mm:ss"))
              secs = this.getSec(moment(sdatetimefullstart).format("HH:mm:ss"))

              houre = this.getHour(moment(sdatetimefullend).format("HH:mm:ss"))
              mine = this.getMin(moment(sdatetimefullend).format("HH:mm:ss"))
              sece = this.getSec(moment(sdatetimefullend).format("HH:mm:ss"))

              let datetimefullstart = new Date(years, months - 1, days, hours, mins, secs)
              let datetimefullend = new Date(yeare, monthe - 1, daye, houre, mine, sece)

              let datestart = new Date(years, months - 1, days)

              let dateShiftr = null, diffDateShiftR = null
              if (!this.isEmpty(obj[5]) && (obj[5] !== null)) {
                dateShiftr = new Date(yearr, monthr - 1, dayr)
                diffDateShiftR = Math.abs(dateShiftr.getTime() - datetimefullstart.getTime())
              }

              let diffDate = datetimefullend.getTime() - datetimefullstart.getTime()

              if ((sdatetimefullstart === "Invalid date") || (sdatetimefullend === "Invalid date") || (diffDate <= 0)
                  || (diffDate >= oneDayInMilliseconds) || ((dateShiftr !== null) && (dateShiftr.getTime() > datestart.getTime()))
                  || ((dateShiftr !== null) && (diffDateShiftR >= oneDayInMilliseconds))) {
                if ((sdatetimefullstart === "Invalid date") || (sdatetimefullend === "Invalid date")) {
                  this.text = "Date invalide."
                } else if (diffDate <= 0) {
                  this.text = "La date de début est pas supérieure ou égale à la date de fin."
                } else if (diffDate >= oneDayInMilliseconds) {
                  this.text = "Les Heures Sup posées pour cet agent ne doivent pas dépasser 24h."
                } else if ((dateShiftr !== null) && (dateShiftr.getTime() > datestart.getTime())) {
                  this.text = "La date début Heures Sup ne peut pas être supérieure à la date du shift."
                } else {
                  this.text = "La date du shift ne peut pas être inférieure de plus de 24h à la date de début Heures Sup."
                }

                this.loading = false
                this.dialog = false;
                this.showAlert('warning')
                this.depthDate()
                dialog.close();
                return;
              }

              newObj = {
                id: obj[0],
                userId: obj[1],
                dateShift: dateShift,
                nameShift: obj[6],
                startFullDateHeuresSup: moment(sdatetimefullstart),
                endFullDateHeuresSup: moment(sdatetimefullend),
                observations: obj[11],
                compensation: obj[13],
              }
              apiClient
                  .post(
                      `${this.$store.getters.user.baseUrl}/account/heuressup/` + sessionStorage.getItem("userId"),
                      newObj
                  )
                  .then(res => {
                    dialog.close();
                    this.loading = false
                    if (res.data.status === 200) {
                      this.color = "#009688"
                      this.text = res.data.message;
                      this.showAlert('info')
                      this.depthDate()
                    } else {
                      this.alert = true
                      this.color = "#F44336"
                      this.text = res.data.message;
                      this.dialog = false;

                      let myData = this.$refs.hotTable.hotInstance.getData()
                      myData[changes[0][0]][changes[0][1]] = changes[0][2]
                      this.$refs.hotTable.hotInstance.loadData(myData)
                      this.showAlert('warning')
                    }
                  })
                  .catch((err) => {
                    dialog.close();
                    let myData = this.$refs.hotTable.hotInstance.getData()
                    myData[changes[0][0]][changes[0][1]] = changes[0][2]
                    this.$refs.hotTable.hotInstance.loadData(myData)

                    this.alert = true
                    this.color = "#F44336"
                    this.text = err.data.message;
                    this.loading = false
                    this.showAlert('warning')

                    this.initEditedItem();
                  });
            })
            .catch(() => {
              let myData = this.$refs.hotTable.hotInstance.getData()
              myData[changes[0][0]][changes[0][1]] = changes[0][2]
              this.$refs.hotTable.hotInstance.loadData(myData)
            });
      }
    },
    beforeRemoveRowMe(index, amount) {
      let rowId = this.$refs.hotTable.hotInstance.getData()[index]
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression des Heures Sup.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true

            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/account/heuressup/` + rowId[0] + "/" + sessionStorage.getItem("userId")
                )
                .then(res => {
                  dialog.close();
                  this.loading = false
                  if (res.data.status === 200) {
                    this.color = "#009688"
                    this.text = res.data.message;
                    this.showAlert('info')
                  } else {
                    this.$refs.hotTable.hotInstance.alter("insert_row_above", index)

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 12, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 13, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 14, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 15, "readOnly", false);

                    this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 12, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 13, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 14, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 15, "readOnly", true);

                    this.color = "#F44336"
                    this.alert = true
                    this.text = res.data.message;
                    this.dialog = false;
                    this.showAlert('warning')
                  }
                })
                .catch((error) => {
                  dialog.close();
                  this.loading = false
                  this.alert = true
                  this.color = "#F44336"
                  this.text = error;
                  this.showAlert('warning')
                });
          })
          .catch(() => {
            this.$refs.hotTable.hotInstance.alter("insert_row_above", index)

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 12, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 13, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 14, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 15, "readOnly", false);

            this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 1, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 12, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 13, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 14, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 15, "readOnly", true);
          });
    },
    creer() {
      this.loading = true

      let sdatetimefullstart = moment(this.editedItem.startDateHeuresSup + " " + this.editedItem.startTimeHeuresSup)
      let sdatetimefullend = moment(this.editedItem.endDateHeuresSup + " " + this.editedItem.endTimeHeuresSup)

      var oneDayInMilliseconds = 86400000;
      let days, months, years, daye, monthe, yeare, dayr, monthr, yearr;
      let hours, mins, secs, houre, mine, sece;

      days = this.getDay(moment(sdatetimefullstart).format("YYYY-MM-DD"))
      months = this.getMonth(moment(sdatetimefullstart).format("YYYY-MM-DD"))
      years = this.getYear(moment(sdatetimefullstart).format("YYYY-MM-DD"))

      daye = this.getDay(moment(sdatetimefullend).format("YYYY-MM-DD"))
      monthe = this.getMonth(moment(sdatetimefullend).format("YYYY-MM-DD"))
      yeare = this.getYear(moment(sdatetimefullend).format("YYYY-MM-DD"))

      if (!this.isEmpty(this.editedItem.shiftDate) && (this.editedItem.shiftDate !== null)) {
        dayr = this.getDay(moment(this.editedItem.shiftDate).format("YYYY-MM-DD"))
        monthr = this.getMonth(moment(this.editedItem.shiftDate).format("YYYY-MM-DD"))
        yearr = this.getYear(moment(this.editedItem.shiftDate).format("YYYY-MM-DD"))
      }

      hours = this.getHour(moment(sdatetimefullstart).format("HH:mm:ss"))
      mins = this.getMin(moment(sdatetimefullstart).format("HH:mm:ss"))
      secs = this.getSec(moment(sdatetimefullstart).format("HH:mm:ss"))

      houre = this.getHour(moment(sdatetimefullend).format("HH:mm:ss"))
      mine = this.getMin(moment(sdatetimefullend).format("HH:mm:ss"))
      sece = this.getSec(moment(sdatetimefullend).format("HH:mm:ss"))

      let datetimefullstart = new Date(years, months - 1, days, hours, mins, secs)
      let datetimefullend = new Date(yeare, monthe - 1, daye, houre, mine, sece)

      let datestart = new Date(years, months - 1, days)

      let dateShiftr = null, diffDateShiftR = null
      if (!this.isEmpty(this.editedItem.shiftDate) && (this.editedItem.shiftDate !== null)) {
        dateShiftr = new Date(yearr, monthr - 1, dayr)
        diffDateShiftR = Math.abs(dateShiftr.getTime() - datetimefullstart.getTime())
      }
      let diffDate = datetimefullend.getTime() - datetimefullstart.getTime()

      if ((sdatetimefullstart === "Invalid date") || (sdatetimefullend === "Invalid date") || (diffDate <= 0)
          || (diffDate >= oneDayInMilliseconds) || ((dateShiftr !== null) && (dateShiftr.getTime() > datestart.getTime()))
          || ((dateShiftr !== null) && (diffDateShiftR >= oneDayInMilliseconds))) {
        if ((sdatetimefullstart === "Invalid date") || (sdatetimefullend === "Invalid date")) {
          this.text = "Date invalide."
        } else if (diffDate <= 0) {
          this.text = "La date de début est pas supérieure ou égale à la date de fin."
        } else if (diffDate >= oneDayInMilliseconds) {
          this.text = "Les Heures Sup posées pour cet agent ne doivent pas dépasser 24h."
        } else if ((dateShiftr !== null) && (dateShiftr.getTime() > datestart.getTime())) {
          this.text = "La date début Heures Sup ne peut pas être supérieure à la date du shift."
        } else {
          this.text = "La date du shift ne peut pas être inférieure de plus de 24h à la date de début Heures Sup."
        }

        this.loading = false
        this.dialog = false;
        this.showAlert('warning')
        this.depthDate()
        return;
      }

      const dataToSave = {
        id: this.isEmpty(this.editedItem.id) ? 0 : this.editedItem.id,
        userId: this.editedItem.userId,
        dateShift: this.isEmpty(this.editedItem.shiftDate) ? null : moment(this.editedItem.shiftDate + " 00:00:00", "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
        nameShift: this.editedItem.shiftName,
        startDayHeuresSup: moment(this.editedItem.startDateHeuresSup + " 00:00:00", "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
        startHourHeuresSup: moment(this.editedItem.startDateHeuresSup + " " + this.editedItem.startTimeHeuresSup, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
        endDayHeuresSup: moment(this.editedItem.endDateHeuresSup + " 00:00:00", "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
        endHourHeuresSup: moment(this.editedItem.endDateHeuresSup + " " + this.editedItem.endTimeHeuresSup, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
        startFullDateHeuresSup: moment(sdatetimefullstart).format("YYYY-MM-DD HH:mm:ss"),
        endFullDateHeuresSup: moment(sdatetimefullend).format("YYYY-MM-DD HH:mm:ss"),
        observations: this.editedItem.observations
      };
      apiClient
          .post(`${this.$store.getters.user.baseUrl}/account/heuressup/false` + "/" + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.dialog = false;
            this.loading = false
            if (res.data.datas.status === 200) {
              this.color = "#009688"
              this.text = res.data.datas.message
              this.initEditedItem();

              this.showAlert('info')
              this.depthDate();
            } else {
              this.color = "#F44336"
              this.alert = true
              this.text = res.data.datas.message;
              this.initEditedItem();

              this.showAlert('warning')
              this.depthDate();
            }
          })
          .catch(error => {
            this.dialog = false;
            this.alert = true
            this.text = error;
            this.loading = false
            this.color = "#F44336"
            this.showAlert('warning')
          });
    },
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.pre-formatted {
  white-space: pre;
}
</style>
<!--

<v-col>
    <v-dialog max-width="900px" persistent v-model="dialog">
        <template @mouseleave.native="hover = false" @mouseover.native="hover = true"
                  v-slot:activator="{ on }">
            <v-btn @click="initdatetime()" block  v-if="false"
                   class="custom-btn white&#45;&#45;text"
                   color="#009688"
                   height="45px" large v-on="on">
                <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                <span>Heures Sup</span>
            </v-btn>
        </template>
        <v-card>
            <v-toolbar
                    color="#01579B"
                    dark
                    flat>
                <v-spacer></v-spacer>
                <v-btn
                        @click="close"
                        dark
                        fab
                        small>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-tabs :grow=true background-color="#01579B" color="#f5f5f5" dark="" right
                    v-model="tab">
                <v-tabs-slider></v-tabs-slider>
                <v-tab href="#tab-1">Formulaire</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item value="tab-1">
                    <v-card-text>
                        <v-container>
                            <v-row class="justify-center align-center">
                                <v-col cols="12" md="6" sm="6">
                                    <v-text-field :id="dynamicID()"
                                                  class="centered-input align-center"
                                                  color="#01579B"
                                                  label="Matricule"
                                                  prepend-inner-icon="mdi-human-male"
                                                  v-model="editedItem.userId">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="justify-center align-center">
                                <v-col cols="12" md="6" sm="6">
                                    <v-menu
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            min-width="290px"
                                            offset-y
                                            transition="scale-transition"
                                            v-model="menu0"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field :id="dynamicID()"
                                                          class="centered-input align-center"
                                                          label="Date Shift (Option)"
                                                          persistent-hint
                                                          prepend-inner-icon="mdi-calendar"
                                                          readonly
                                                          v-bind="attrs"
                                                          v-model="computedDateFormatted0"
                                                          v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                @input="menu0= false"
                                                locale="fr-FR"
                                                v-model="editedItem.shiftDate"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                            <v-row class="justify-center align-center">
                                <v-col cols="12" md="6" sm="6">
                                    <v-select :items="shifts"
                                              class="centered-input align-center text-center"
                                              color="#01579B"
                                              item-text="type"
                                              item-value="type"
                                              label="Nom Shift (Option)"
                                              prepend-inner-icon="mdi-selection-ellipse-arrow-inside"
                                              v-model="editedItem.shiftName">
                                        <template v-slot:selection="{ item }">
                                                                      <span class="d-flex justify-center" style="width: 100%;">
                                                                        {{ item }}
                                                                      </span>
                                        </template>
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6" sm="6">
                                    <v-menu
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            min-width="290px"
                                            offset-y
                                            transition="scale-transition"
                                            v-model="menu1"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field :id="dynamicID()"
                                                          class="centered-input align-center"
                                                          label="Date début Heures Sup"
                                                          persistent-hint
                                                          prepend-inner-icon="mdi-calendar"
                                                          readonly
                                                          v-bind="attrs"
                                                          v-model="computedDateFormatted1"
                                                          v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                @input="menu1= false"
                                                locale="fr-FR"
                                                v-model="editedItem.startDateHeuresSup"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="6" sm="6">
                                    <v-dialog
                                            :return-value.sync="editedItem.startTimeHeuresSup"
                                            persistent
                                            ref="dialog"
                                            v-model="modal2"
                                            width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field :id="dynamicID()"
                                                          class="centered-input align-center"
                                                          label="Heure début Heures Sup"
                                                          prepend-inner-icon="access_time"
                                                          readonly
                                                          v-bind="attrs"
                                                          v-model="computedDateFormatted11"
                                                          v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-time-picker
                                                :useSeconds=true
                                                format="24hr"
                                                full-width
                                                v-if="modal2"
                                                v-model="editedItem.startTimeHeuresSup"
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn @click="modal2 = false" color="primary" text>
                                                Annuler
                                            </v-btn>
                                            <v-btn @click="$refs.dialog.save(editedItem.startTimeHeuresSup)"
                                                   color="primary" text>Valider
                                            </v-btn>
                                        </v-time-picker>
                                    </v-dialog>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6" sm="6">
                                    <v-menu
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            min-width="290px"
                                            offset-y
                                            transition="scale-transition"
                                            v-model="menu2"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field :id="dynamicID()"
                                                          class="centered-input align-center"
                                                          label="Date fin Heures Sup"
                                                          persistent-hint
                                                          prepend-inner-icon="mdi-calendar"
                                                          readonly
                                                          v-bind="attrs"
                                                          v-model="computedDateFormatted2"
                                                          v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                @input="menu2= false"
                                                locale="fr-FR"
                                                v-model="editedItem.endDateHeuresSup"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="6" sm="6">
                                    <v-dialog
                                            :return-value.sync="editedItem.endTimeHeuresSup"
                                            persistent
                                            ref="dialog3"
                                            v-model="modal3"
                                            width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field :id="dynamicID()"
                                                          class="centered-input align-center"
                                                          label="Heure fin Heures Sup"
                                                          prepend-inner-icon="access_time"
                                                          readonly
                                                          v-bind="attrs"
                                                          v-model="computedDateFormatted22"
                                                          v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-time-picker
                                                :useSeconds=true
                                                format="24hr"
                                                full-width
                                                v-if="modal3"
                                                v-model="editedItem.endTimeHeuresSup"
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn @click="modal3 = false" color="primary" text>
                                                Annuler
                                            </v-btn>
                                            <v-btn @click="$refs.dialog3.save(editedItem.endTimeHeuresSup)"
                                                   color="primary" text>Valider
                                            </v-btn>
                                        </v-time-picker>
                                    </v-dialog>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12" sm="12">
                                    <v-text-field :id="dynamicID()"
                                                  class="centered-input align-center"
                                                  color="#01579B" label="Observations"
                                                  prepend-inner-icon="mdi-comment-edit-outline"
                                                  rows="1"
                                                  textarea
                                                  v-model="editedItem.observations"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!FormIsValid && !loading" @click="creer"
                               class="white&#45;&#45;text"
                               color="#01579B" depressed>Créer Heures Sup
                        </v-btn>
                    </v-card-actions>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </v-dialog>
</v-col>-->
